<template>
  <div class="row">
    <div class="col-12">
      <div class="page_title">
        商品項目購買
      </div>
    </div>
    <div class="col-12 mb-5">
      <button-wrapper
        color="pink"
        @click="batchDelete"
      >
        刪除已勾選項目
        <font-awesome-icon :icon="['far', 'trash-alt']" />
      </button-wrapper>
    </div>
    <div class="col-12 mb-5">
      <print-advertising-spreadsheet
        ref="spreadsheet"
        :enrolled-ads="enrolledAds || {}"
        :advertisements="currentAdvertisementsGetter.ads"
        @ads:changed="updatePrintAdvertisingSubtotal"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ButtonWrapper from '~components/common/buttons'
import PrintAdvertisingSpreadsheet from '../common/PrintAdvertisingSpreadsheet'

export default {
  name: 'EnterpriseEditPrintAdvertising',
  components: {
    ButtonWrapper,
    PrintAdvertisingSpreadsheet
  },
  props: {
    enrolledAds: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters('pages/campus-recruiting', [
      'currentAdvertisementsGetter'
    ])
  },
  methods: {
    updatePrintAdvertisingSubtotal (printAdvertising) {
      this.$emit('ads:changed', printAdvertising)
    },
    batchDelete () {
      this.$refs.spreadsheet.batchDeleteItems()
    },
    resetAds () {
      this.$refs.spreadsheet.resetSpreadsheet()
    }
  }
}
</script>
